import { parseDef } from "../parseDef.js";

//#region src/utils/zod-to-json-schema/parsers/branded.ts
function parseBrandedDef(_def, refs) {
	return parseDef(_def.type._def, refs);
}

//#endregion
export { parseBrandedDef };
//# sourceMappingURL=branded.js.map